import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function getFeatures() {
  const apiPath = API.FEATURES
  return axiosService({ method: 'GET', apiPath })
}
